if (typeof Connect == 'undefined') Connect = { contextRoot: '/connect' };

Connect.IntegrationEvent = Backbone.Model.extend({

});

Connect.IntegrationEvents = Backbone.Collection.extend({
    model: Connect.IntegrationEvent,
    url: function() {
        var url;
        if (this.groupUuid)
            url = Connect.contextRoot + '/event/group/' + this.groupUuid;
        else if (this.integrationId)
            url = Connect.contextRoot + '/event/integration/' + this.integrationId;
        else
            throw 'No path for integration events';
        if (this.filterParams)
            url += '?' + $.param(this.filterParams);
        return url;
    },
    initialize: function(models, options) {
        if (options) {
            this.groupUuid = options.groupUuid;
            this.integrationId = options.integrationId;
            this.filterParams = options.filterParams;
        }
    },
});
